<template>
  <div>
    <div class="form-group">
      <label for="source_repository">Quell-Repository</label>
      <v-select
          id="source_repository"
          :options="repositoryOptions"
          v-model="sourceRepository"
          :reduce="repo => repo.id"
          label="label"
          placeholder="-- Bitte wählen --"
          @input="updateSourceBranchesAndTags"
      ></v-select>
    </div>
    <div class="form-group">
      <label for="source_branch">Quell-Branch</label>
      <v-select
          id="source_branch"
          :options="sourceBranchOptions"
          v-model="sourceBranch"
          label="name"
          placeholder="-- Bitte wählen --"
          :reduce="branch => Number(branch.id)"
      ></v-select>
    </div>
    <div class="form-group">
      <label for="source_tag">Quell-Tag</label>
      <v-select
          id="source_tag"
          :options="sourceTagOptions"
          v-model="sourceTag"
          label="name"
          placeholder="-- Bitte wählen --"
          :reduce="tag => Number(tag.id)"
          :disabled="!sourceTagOptions.length"
      ></v-select>
    </div>
    <div class="form-group">
      <label for="target_repository">Ziel-Repository</label>
      <v-select
          id="target_repository"
          :options="repositoryOptions"
          v-model="targetRepository"
          :reduce="repo => repo.id"
          label="label"
          placeholder="-- Bitte wählen --"
          @input="updateTargetBranches"
      ></v-select>
    </div>
    <div class="form-group">
      <label>
        <input type="checkbox" v-model="createAutomatedTargetBranch" @change="handleTargetBranchCheckbox">
        Automatisch generierten Ziel-Branch erstellen
      </label>
    </div>
    <div class="form-group">
      <label for="target_branch">Ziel-Branch</label>
      <v-select
          id="target_branch"
          :options="targetBranchOptions"
          v-model="targetBranch"
          label="name"
          placeholder="-- Bitte wählen --"
          :reduce="branch => Number(branch.id)"
          :disabled="createAutomatedTargetBranch"
      ></v-select>
    </div>
    <!-- Hidden fields to bind to the form model -->
    <input type="hidden" name="source_repository_id" :value="sourceRepository">
    <input type="hidden" name="source_branch_id" :value="sourceBranch">
    <input type="hidden" name="source_tag_id" :value="sourceTag">
    <input type="hidden" name="target_repository_id" :value="targetRepository">
    <input type="hidden" name="target_branch_id" :value="targetBranch">
    <input type="hidden" name="create_automated_target_branch" :value="createAutomatedTargetBranch ? 1 : 0">
  </div>
</template>

<script>
export default {
  name: "RepositoryBranchSelector",
  props: {
    repositories: {
      type: Object,
      required: true
    },
    allBranches: {
      type: Array,
      default: () => []
    },
    allTags: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: "-- Bitte wählen --"
    },
    initialSourceRepositoryId: {
      type: [String, Number],
      default: ''
    },
    initialTargetRepositoryId: {
      type: [String, Number],
      default: ''
    },
    initialSourceBranchId: {
      type: [String, Number],
      default: ''
    },
    initialSourceTagId: {
      type: [String, Number],
      default: ''
    },
    initialTargetBranchId: {
      type: [String, Number],
      default: ''
    },
    initialCreateAutomatedTargetBranch: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // Convert initial values to numbers if possible
      sourceRepository: this.initialSourceRepositoryId ? Number(this.initialSourceRepositoryId) : '',
      targetRepository: this.initialTargetRepositoryId ? Number(this.initialTargetRepositoryId) : '',
      sourceBranch: this.initialSourceBranchId ? Number(this.initialSourceBranchId) : '',
      sourceTag: this.initialSourceTagId ? Number(this.initialSourceTagId) : '',
      targetBranch: this.initialTargetBranchId ? Number(this.initialTargetBranchId) : '',
      sourceBranchOptions: [],
      sourceTagOptions: [],
      targetBranchOptions: [],
      createAutomatedTargetBranch: this.initialCreateAutomatedTargetBranch
    };
  },
  computed: {
    repositoryOptions() {
      return Object.entries(this.repositories).map(([id, slug]) => ({
        id: Number(id),
        label: slug
      }));
    }
  },
  methods: {
    updateSourceBranchesAndTags() {
      const sourceId = Number(this.sourceRepository);

      // Update branches
      const filteredBranches = this.allBranches.filter(
          branch => Number(branch.repository_id) === sourceId
      );
      this.sourceBranchOptions = filteredBranches;
      const branchExists = filteredBranches.some(branch => Number(branch.id) === Number(this.sourceBranch));
      if (!branchExists) {
        this.sourceBranch = '';
      }

      // Update tags
      const filteredTags = this.allTags.filter(
          tag => Number(tag.repository_id) === sourceId
      );
      this.sourceTagOptions = filteredTags;
      const tagExists = filteredTags.some(tag => Number(tag.id) === Number(this.sourceTag));
      if (!tagExists) {
        this.sourceTag = '';
      }
    },
    updateTargetBranches() {
      const targetId = Number(this.targetRepository);
      const filtered = this.allBranches.filter(
          branch => Number(branch.repository_id) === targetId
      );
      this.targetBranchOptions = filtered;
      const exists = filtered.some(branch => Number(branch.id) === Number(this.targetBranch));
      if (!exists) {
        this.targetBranch = '';
      }
    },
    handleTargetBranchCheckbox() {
      if (this.createAutomatedTargetBranch) {
        this.targetBranch = '';
      }
    }
  },
  mounted() {
    if (this.sourceRepository) {
      this.updateSourceBranchesAndTags();
    }
    if (this.targetRepository) {
      this.updateTargetBranches();
    }
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 15px;
}
</style>